module.exports = __webpack_public_path__ + "static/img/bc1-1.b834aa4.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/SaveFile/bc1-1.png
// module id = 817
// module chunks = 0